var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-for-request',{attrs:{"id-request":Number(_vm.requestId),"type-request":"Massive"}})}
var staticRenderFns = []

export { render, staticRenderFns }